var map = {
	"./ObjectsRender/xNegTurn.svg": "81c8",
	"./ObjectsRender/xPosTurn.svg": "ce17",
	"./ObjectsRender/yNegTurn.svg": "07cc",
	"./ObjectsRender/yPosTurn.svg": "9acd",
	"./ObjectsRender/zNegTurn.svg": "8064",
	"./ObjectsRender/zPosTurn.svg": "730e",
	"./arrowLarge.svg": "21c7",
	"./cameraIcon.svg": "8d86",
	"./caveman/NewPlayer/airSwing1.svg": "936e",
	"./caveman/NewPlayer/airSwing2.svg": "da6c",
	"./caveman/NewPlayer/airSwing3.svg": "0c5a",
	"./caveman/NewPlayer/airSwing4.svg": "189b",
	"./caveman/NewPlayer/airSwing5.svg": "f8d6",
	"./caveman/NewPlayer/airSwing6.svg": "5669",
	"./caveman/NewPlayer/down.svg": "680d",
	"./caveman/NewPlayer/hit1.svg": "e714",
	"./caveman/NewPlayer/hit2.svg": "c7b8",
	"./caveman/NewPlayer/run1.svg": "7672",
	"./caveman/NewPlayer/run2.svg": "91a8",
	"./caveman/NewPlayer/run3.svg": "6be6",
	"./caveman/NewPlayer/run4.svg": "8e99",
	"./caveman/NewPlayer/run5.svg": "0b02",
	"./caveman/NewPlayer/run6.svg": "9070",
	"./caveman/NewPlayer/run7.svg": "faf1",
	"./caveman/NewPlayer/run8.svg": "ab33",
	"./caveman/NewPlayer/stand.svg": "683e",
	"./caveman/NewPlayer/swingcycle1.svg": "a0f4",
	"./caveman/NewPlayer/swingcycle2.svg": "9db7",
	"./caveman/NewPlayer/swingcycle3.svg": "9ff9",
	"./caveman/NewPlayer/swingcycle4.svg": "7d05",
	"./caveman/NewPlayer/swingcycle5.svg": "7740",
	"./caveman/NewPlayer/swingcycle6.svg": "6960",
	"./caveman/NewPlayer/up.svg": "ed10",
	"./caveman/deleteCross.svg": "9793",
	"./caveman/obs/diamond.svg": "7945",
	"./caveman/obs/emerald.svg": "e5cd",
	"./caveman/obs/logs.svg": "5e56",
	"./caveman/obs/logsFire.svg": "66d6",
	"./caveman/obs/meat.svg": "97bd",
	"./caveman/obs/ruby.svg": "8ba6",
	"./caveman/obs/test.svg": "8488",
	"./caveman/obs/vent.svg": "49c7",
	"./checkTicked.svg": "429c",
	"./checkUnticked.svg": "b4f8",
	"./cog.svg": "e6ab",
	"./crossHair.svg": "9c09",
	"./deleteIcon.svg": "a2ef",
	"./downloadIcon.svg": "577a",
	"./dropDownButton.svg": "499c",
	"./drumKit/backdrop.svg": "f796",
	"./drumKit/cymbalLeft.svg": "7f64",
	"./drumKit/cymbalLeftHit.svg": "10d6",
	"./drumKit/cymbalRight.svg": "b307",
	"./drumKit/cymbalRightHit.svg": "36f5",
	"./drumKit/highHat.svg": "6b41",
	"./drumKit/highHatHit.svg": "8210",
	"./drumKit/kickDrum.svg": "fd8c",
	"./drumKit/kickDrumHit.svg": "7f07",
	"./drumKit/snare.svg": "56dd",
	"./drumKit/snareHit.svg": "efd4",
	"./drumKit/tomLarge.svg": "63a6",
	"./drumKit/tomLargeHit.svg": "86cc",
	"./drumKit/tomMid.svg": "21c7a",
	"./drumKit/tomMidHit.svg": "a527",
	"./drumKit/tomSmall.svg": "d4d5",
	"./drumKit/tomSmallHit.svg": "0ed4",
	"./filterIcon.svg": "67b7",
	"./fishBowl/backdrop.svg": "1853",
	"./fishBowl/bubble.svg": "9f2e",
	"./fishBowl/castle.svg": "ad80",
	"./fishBowl/crabBlink.svg": "3824",
	"./fishBowl/crabWalkOne.svg": "e57b",
	"./fishBowl/crabWalkTwo.svg": "6d85",
	"./fishBowl/fishBase.svg": "4660",
	"./fishBowl/fishBlinkOne.svg": "2503",
	"./fishBowl/fishBlinkTwo.svg": "2dc0",
	"./fishBowl/fishMove.svg": "69e2",
	"./fishBowl/rock.svg": "845b",
	"./icons/arrow.svg": "5975",
	"./jsButtons/downer.svg": "5ce7",
	"./jsButtons/dropDownButton.svg": "d226",
	"./jsButtons/load.svg": "3483",
	"./jsButtons/loadS.svg": "4076",
	"./jsButtons/menuBar.svg": "f980",
	"./jsButtons/new.svg": "e15b",
	"./jsButtons/newS.svg": "c109",
	"./jsButtons/overwrite.svg": "cfcb",
	"./jsButtons/overwriteS.svg": "73b6",
	"./jsButtons/save.svg": "8fc9",
	"./jsButtons/saveS.svg": "8552",
	"./jsButtons/switchOff.svg": "49f5",
	"./jsButtons/switchOn.svg": "79f1",
	"./jsButtons/upper.svg": "a09b",
	"./jsButtons/xSlider.svg": "62fa",
	"./jsButtons/ySlider.svg": "9784",
	"./noTouch.svg": "c636",
	"./raycaster/close.svg": "ae15",
	"./raycaster/close2.svg": "6135",
	"./raycaster/full.svg": "483d",
	"./raycaster/full2.svg": "3357",
	"./raycasterWalls/pharaohTextWings.svg": "0ffb",
	"./rotate.svg": "600a",
	"./selectArrow.svg": "dd10",
	"./shadowExpand.svg": "6f71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";